export default __webpack_public_path__ + "static/media/lumberjack.ae378c2e.png";